type PageLocation = { protocol: string; hostname: string };

export function resolveApiUrl(location?: PageLocation, configuredUrl?: string): string {
  if (configuredUrl?.trim()) {
    const url = new URL(configuredUrl.trim());
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
      throw new Error("API_URL должен быть адресом HTTP/HTTPS без пароля, query или fragment");
    }
    if (!url.pathname.endsWith('/')) url.pathname += '/';
    return url.toString();
  }
  if (!location?.hostname) return "https://api.localhost/";
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return "http://localhost:9612/";
  }
  return `${location.protocol}//api.${location.hostname}/`;
}
